var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',{staticClass:"d-none d-sm-block",attrs:{"id":"leftNav"}},[_c('b-navbar',[_c('ItemsList',{attrs:{"allLessons":_vm.allLessons,"courseSlug":_vm.courseSlug}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }